// Termos de Uso e Política de Privacidade (conta-login, AC-087 / AC-088): pop-up por cima do
// cadastro. Texto nas traduções (namespace "legal"); responsável e foro a preencher (ASM-042).
import { useTranslation } from 'react-i18next';
import { LEGAL_UPDATED, LEGAL_VARS, type LegalDoc, type LegalSection } from '../domain/legal';
import { Dialog } from './EditTaskDialog';
import { Icon } from './Icon';

export function LegalDialog({ doc, onClose }: { doc: LegalDoc; onClose: () => void }) {
  const { t } = useTranslation('legal');
  const sections = t(`${doc}.sections`, { returnObjects: true, ...LEGAL_VARS }) as unknown as LegalSection[];
  // a data segue o idioma do texto exibido (sem tradução, o texto vem em inglês ou pt-BR)
  const date = new Intl.DateTimeFormat(t('locale'), { dateStyle: 'long' }).format(new Date(`${LEGAL_UPDATED}T12:00:00`));
  const close = t('common.close', { ns: 'translation' });
  return (
    <Dialog labelId="legal-title" onClose={onClose} className="dialog--legal">
      <div className="dialog__head">
        <div>
          <h2 id="legal-title" className="dialog__title">
            {t(`${doc}.title`)}
          </h2>
          <p className="legal__updated">{t('updated', { date })}</p>
        </div>
        <button type="button" className="icon-btn" aria-label={close} onClick={onClose}>
          <Icon name="x" size={16} />
        </button>
      </div>
      <div className="legal__doc" data-testid={`legal-${doc}`}>
        <p>{t(`${doc}.intro`)}</p>
        {sections.map((s) => (
          <section key={s.id} className="legal__section" data-section={s.id}>
            <h3>{s.title}</h3>
            {s.body.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </section>
        ))}
      </div>
      <div className="dialog__actions">
        <button type="button" className="btn btn--primary" onClick={onClose}>
          {close}
        </button>
      </div>
    </Dialog>
  );
}
